import type { ReactElement, ReactNode } from 'react';
import {
  ListBoxItem,
  type ListBoxItemProps,
  type ListBoxItemRenderProps,
} from 'react-aria-components';
import cx from 'clsx';
import { CheckboxIndicator } from '#components/checkbox/checkbox-indicator';
import styles from './option.module.css';

interface OptionProps extends Omit<ListBoxItemProps, 'children'> {
  beforeContent?: ReactNode;
  afterContent?: ReactNode;
  afterContentClassName?: string;
  beforeContentClassName?: string;
  labelClassName?: string;
  children: ReactNode | ((renderProps: ListBoxItemRenderProps) => ReactNode);
}

export function Option({
  beforeContent,
  afterContent,
  className,
  afterContentClassName,
  beforeContentClassName,
  labelClassName,
  children,
  ...props
}: OptionProps): ReactElement {
  return (
    <ListBoxItem
      className={cx(styles.option, className)}
      textValue={typeof children === 'string' ? children : undefined}
      {...props}
    >
      {(renderProps: ListBoxItemRenderProps) => {
        const childContent = typeof children === 'function' ? children(renderProps) : children;

        return (
          <>
            <CheckboxIndicator className={styles.checkbox} isSelected={renderProps.isSelected} />
            {beforeContent ? (
              <div className={cx(styles.beforeContent, beforeContentClassName)}>
                {beforeContent}
              </div>
            ) : null}
            <span className={cx(styles.label, labelClassName)}>{childContent}</span>
            {afterContent ? (
              <div className={cx(styles.afterContent, afterContentClassName)}>{afterContent}</div>
            ) : null}
          </>
        );
      }}
    </ListBoxItem>
  );
}
